import { StyledHeaderBanner, BannerSkeleton } from './HeaderBanner.styled'
import { useState } from 'react'

export const HeaderBanner = ({ src }: { src: string }) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <>
      {isLoading && <BannerSkeleton />}
      <StyledHeaderBanner src={src} alt="Banner" onLoad={() => setIsLoading(false)} style={{ display: isLoading ? 'none' : 'block' }} />
    </>
  )
}

export default HeaderBanner
